import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, NgZone, ChangeDetectorRef } from '@angular/core';
import { embedDashboard } from '@superset-ui/embedded-sdk'
import { HttpSupersetService } from '../../../service/http-superset.service';
import { catchError, firstValueFrom } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpAnalyticsService } from '../../../service/http-analytics.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AgentDto, DashboardRequestDto } from '../../../service/dto';

@Component({
	selector: 'app-analytics-landing-page',
	standalone: false,
	templateUrl: './analytics-landing-page.component.html',
	styleUrls: ['./analytics-landing-page.component.scss'],
})
export class AnalyticsLandingPageComponent implements AfterViewInit {

	@ViewChild('dashboardContainer', { static: false }) dashboardContainer!: ElementRef;

    agents: AgentDto[] = []
	dashboardEmbeddedId!: string;

	dashboardSet: boolean | null = null;

    selectedAgentId: number | null = null;
    selectedDateRange: Date[] = [];
	
	constructor(private httpService: HttpAnalyticsService, private ngZone: NgZone, private message: NzMessageService){}

	ngAfterViewInit(): void {
        this.fetchAgents();
		this.fetchFavouriteDashboard();
	}

    onFilterChange() {
        this.embedSupersetDashboard();
    }

    private fetchAgents() {
        this.httpService.getAgentsWithMovements().subscribe({
            next: (res) => {
                this.agents = res
            },
            error: (error) => {
                console.error('Failed to fetch agents with movements');
				this.message.error('An error occurred fetching agent list');
            }
        });
    }

	private fetchFavouriteDashboard() {
        this.httpService.getFavourite().subscribe({
            next: (res) => {
                // FORCE BACK INTO ANGULAR ZONE
                this.ngZone.run(() => {
                    // Check if res is null, undefined, or an empty string
                    if (!res || (typeof res === 'string' && res.trim() === '')) {
                        console.log('Result is empty, setting dashboardSet = false');
                        this.dashboardSet = false;
                        return;
                    }

                    console.log('Result found:', res);
                    this.dashboardEmbeddedId = res;
                    this.dashboardSet = true;

                    // Embed after view updates
                    setTimeout(() => {
                        this.embedSupersetDashboard();
                    }, 100);
                });
            },
            error: (error) => {
                this.ngZone.run(() => {
                    console.error('API Error, setting dashboardSet = false');
					this.message.error('You have not set a dashboard as your home page');
                    this.dashboardSet = false;
                });
            }
        });
    }

	private async embedSupersetDashboard() {
        if (!this.dashboardSet || !this.dashboardContainer?.nativeElement) return;

        try {

            const fromDate = this.selectedDateRange && this.selectedDateRange[0] ? this.selectedDateRange[0] : null;
            const toDate = this.selectedDateRange && this.selectedDateRange[1] ? this.selectedDateRange[1] : null;

            var payload: DashboardRequestDto = {
                dashboardEmbeddedId: this.dashboardEmbeddedId,
                agentId: this.selectedAgentId ? this.selectedAgentId : undefined, // Send undefined/null if empty
                from: fromDate ?? undefined, // Angular HttpClient usually handles Date -> ISO string serialization automatically
                to: toDate ?? undefined
            };
            await embedDashboard({
                id: this.dashboardEmbeddedId,
                supersetDomain: "https://superset.pandadigital.co.za",
                mountPoint: this.dashboardContainer.nativeElement,
                fetchGuestToken: () => new Promise((resolve, reject) => 
                    this.httpService.fetchGuestToken(payload).subscribe({
                        next: (res) => resolve(res.guestToken), // Extract the string string
                        error: (err) => reject(err)             // Handle HTTP errors
                    })
                ),
                dashboardUiConfig: { 
                    hideTitle: true,
                    filters: { expanded: true }
                },
                iframeSandboxExtras: ['allow-top-navigation', 'allow-popups-to-escape-sandbox'],
				referrerPolicy: "no-referrer-when-downgrade",
                debug: true,
				
            });

            const iframe = this.dashboardContainer.nativeElement.querySelector('iframe') as HTMLIFrameElement;
            if (iframe) {
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.style.border = 'none'; // cleaner look
				iframe.style.display = 'block';
            }

        } catch (e) {
            console.error('Error embedding dashboard:', e);
        }
    }

    getAgentDisplayValue(agent: AgentDto) {
        return agent.firstName + ' ' + agent.lastName + ' (' + agent.username + ')';
    }
}
